// useFetch3.ts
// добавление зависимостей
import { useState, useEffect, useCallback, useRef } from "react";

export function useFetch<T>(
  apiCall: (payload?: any) => Promise<T>,
  defaultValue: T,
  initialPayload: any = {},
  dependencies: any[] = [],
  onLoad?: (data: T) => void, 
) {
  const [data, setData] = useState<T>(defaultValue);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  
  const [payload, setPayload] = useState(initialPayload);
  
  // Стабилизируем ссылку на колбек, чтобы не попасть в зависимости fetchData
  const onLoadRef = useRef(onLoad);
  useEffect(() => { onLoadRef.current = onLoad; }, [onLoad]);

  const fetchData = useCallback(
    async (pl: any = payload) => {
      setLoading(true);
      setError(null);
      try {
        const result = await apiCall(pl);
        setData(result);
        onLoadRef.current?.(result);
      } catch (err) {
        setError(err instanceof Error ? err : new Error(String(err)));
      } finally {
        setLoading(false);
      }
    },
    [apiCall] // Видаляємо payload звідси, щоб уникнути зациклення
  );

  // Слідкуємо за зміною залежностей (наприклад, customer_id)
  useEffect(() => {
    // Оновлюємо внутрішній payload, якщо прийшли нові пропси
    setPayload(initialPayload);
    fetchData(initialPayload);
  }, dependencies); // Ось тут відбувається "магія" оновлення

  const update = useCallback(
    async (newPayload: any = {}) => {
      setPayload(newPayload);
      await fetchData(newPayload);
    },
    [fetchData]
  );

  return { data, loading, error, setData, update, refresh: () => fetchData(payload) };
}